import { IRevenueAndSobCategoryRow } from '../revenueAndSob'

import { getFinancialAchievementScore } from './getFinancialAchievementScore'
import { getSobAchievementScore } from './getSobAchievementScore'
import { IAchievementScoreCategoryRow } from './types'

const mapToAchievementScoreRow = ({
  category,
  isTotal,
  sales,
  sob,
}: IRevenueAndSobCategoryRow): IAchievementScoreCategoryRow => ({
  category,
  isTotal,
  financial: {
    baseline: sales.baseline,
    plan: sales.plan,
    actuals: sales.actuals,
    score: getFinancialAchievementScore(sales.actuals, sales.plan),
    quota: sales.quota,
  },
  sob: {
    baseline: sob.baseline,
    plan: sob.plan,
    actuals: sob.actuals,
    score: getSobAchievementScore(sob.actuals, sob.plan, sob.baseline),
    quota: sob.quota,
  },
})

/** Per-category Achievement rows behind the pillar badges, derived from the same category
 *  breakdown the Revenue & SOB table renders — including the `OVERALL_CATEGORY` total, same as
 *  `getRevenueAndSobByCategory` returns it.
 *
 *  Every row, the Total included, scores its own baseline/plan/actuals — the same rule
 *  `getScoredHierarchyRows` applies to the tree. The Total row's figures are the offering-wide
 *  aggregate, so its score is what the hierarchy's root row reads, and the badge built from it
 *  cannot contradict the table beneath it. Averaging the per-category scores instead would break
 *  that: the scores are clamped to 0-100, so overshoot can't offset undershoot, and an unweighted
 *  mean lets a marginal category count as much as one carrying most of the revenue. */
export const getAchievementScoreRows = (
  rows: IRevenueAndSobCategoryRow[]
): IAchievementScoreCategoryRow[] => rows.map(mapToAchievementScoreRow)
